'use client';
import React from 'react';
// import { motion } from 'framer-motion'; // Import motion from framer-motion
import style from './HeroSection.module.scss';
import { cn } from '@/lib/utils';
import { Icons } from '@/components/icons';
import { Metrix } from '@/components/client/Metrix/Metrix';
import teamImage from '@/public/images/home/team.webp';
import carImage from '@/public/images/home/car.webp';
import gradientImage from '@/public/images/home/gradient.webp';
import Image from 'next/image';
// import { CompanyLabel } from '@/components/client/CompanyLabel/CompanyLabel';
import Button from '@/components/ui/Button/Button';
import { useModalContext } from '@/context/ModalsContext';

const metrixItems = [
  { title: 'Total Customer', count: '1500', mark: '+' },
  { title: 'Client Satisfaction', count: '100', mark: '%' },
  { title: 'Team Members', count: '50', mark: '+' },
];

// const heroVariants = {
//   hidden: { opacity: 0, y: -20 },
//   visible: { opacity: 1, y: 0 },
// };

export const HeroSection = () => {
  const { setisModalQuoteOpen } = useModalContext();
  return (
    <div
      className={cn(
        style.wrapper,
        'flex w-full flex-col justify-between md:flex-row'
      )}
      /*  initial="hidden"
      animate="visible"
      variants={heroVariants}
      transition={{ duration: 0.6 }} // Adjust duration as needed */
    >
      <div className="w-full lg:w-3/5">
        <div
          className="mb-4 md:mb-6"
          /*  variants={heroVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.6, delay: 0.2 }} // Stagger animations */
        >
          <h1 className="font-poppins text-left text-[28px] font-semibold leading-[1.1] sm:text-[36px] md:text-[48px] lg:text-[56px] xl:text-[64px]">
            Tytum — Professional HVAC, Electrical, Plumbing, and Other Services
            in San Diego
          </h1>
        </div>

        <p
          className="text-customGray mb-8 max-w-[420px] text-left text-[14px] font-normal leading-[24px] sm:max-w-[480px] sm:text-[15px] sm:leading-[26px] md:mb-10 md:max-w-[520px] md:text-[16px] md:leading-[28px] lg:max-w-[580px] lg:text-[17px] lg:leading-[30px]"
          /*  variants={heroVariants}
          initial="hidden"
          animate="visible"
          transition={{ duration: 0.6, delay: 0.4 }} // Stagger animations */
        >
          Tytum is your one-stop provider for a whole range of services to keep
          your home or business in top shape. From one-time electrical or
          plumbing repairs to full-stack HVAC installations to turnkey
          remodeling and construction projects, we can do it all, providing
          quality and craftsmanship you can count on.
        </p>

        <div className="mb-8 text-left md:mb-12">
          <Button
            onClick={() =>
              window.open(
                'https://app.orcatec.com/public-appointments?nc3tXxmbld',
                '_blank'
              )
            }
            variant="main"
          >
            <p className="flex w-full items-center justify-between gap-10 md:w-[412px]">
              <span>Book a Service</span>{' '}
              <span>
                <Icons.callToAction />
              </span>
            </p>
          </Button>
        </div>
        <Metrix items={metrixItems} />
      </div>

      <div className="xl-custom:block relative hidden w-full md:w-1/2 lg:w-2/5">
        <div className="relative">
          <div className="relative z-40 flex justify-end">
            <button
              className="mb-16 mt-[200px] flex w-fit cursor-pointer items-center gap-6 rounded-full bg-black px-5 py-2 text-start text-lg text-white"
              /*  variants={heroVariants}
              initial="hidden"
              animate="visible"
              transition={{ duration: 0.6, delay: 0.6 }} */
              onClick={(e) => {
                e.stopPropagation();
                setisModalQuoteOpen(true);
              }}
            >
              <span>
                <Icons.homeSetting />
              </span>{' '}
              <span>Get a Free Quote</span>
            </button>
          </div>
          <div className={cn(style.carWrapper, 'absolute z-20')}>
            <Image src={carImage} alt="car" priority />
          </div>
          <div className={cn(style.gradientWrapperBg, 'absolute z-10')}>
            <Image src={gradientImage} alt="car" priority />
          </div>
        </div>
        <div className="bottom-30 absolute z-30">
          <Image src={teamImage} alt="team" priority />
        </div>
      </div>
    </div>
  );
};
